import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';
import { CurrencyUnit } from '../../models/currencyunit';
import { CurrencyUnitService } from '../../services/currencyunit.service';
import { CoreSaveService, UtilsService, MessageService, ICommonMessage, FieldType, ConfigService } from '@gbs-platform-client/fwk-core'
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { CurrencyService } from '../../services/currency.service';
import { Currency } from '../../models/currency';

@Component({
  selector: 'app-currencyunit',
  templateUrl: './currencyunit.component.html',
  styleUrls: ['./currencyunit.component.css']
})
export class CurrencyUnitComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  @ViewChild('view') view!: TemplateRef<any>;
  private unsubscribe$: Subject<void> = new Subject<void>();
  headerCurrencyUnit: PageHeader;
  entity: CurrencyUnit = new CurrencyUnit();
  selectedCurrencyUnit: CurrencyUnit = new CurrencyUnit();
  editingEntity: CurrencyUnit = new CurrencyUnit();
  currencyunits: any;
  currencyunitColumns: any[]=[];
  listView: boolean = true;
  formCaption: string = '';
  currency: Array<Currency> = [];
  selectedCurrency: any;
  emailcheck: boolean = true;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  defaultRowsCount: number;
  saveDisabled: boolean = false;
  opened: boolean = false;
  details: any;
  constructor(
    private _currencyunitService: CurrencyUnitService,
    private _currencyService: CurrencyService,
    private _coreSaveService: CoreSaveService,
    private configService: ConfigService,
    private messageService: MessageService,
    private notification: NotificationsService,
  ) {
    this.headerCurrencyUnit = this.initPageHeader();
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));
    this.currencyunits = [];
    this.getAllCurrencyUnit();
  }
    ngAfterViewInit(): void {
    this.currencyunitColumns = [
      { field: "SlNo", title: 'SL No.', filter: false, sortable: true, width: 100 },
      { field: "CurrencyUnitName", title: 'Currency Unit', filter: true, sortable: true, width: 150  },
      { field: "CurrencyUnitCode", title: 'Code', filter: true, sortable: true, width: 100  },
      { field: "CurrencyName", title: 'Currency', filter: true, sortable: true, width: 150  },
      { field: "Active", title: 'Active', filter: false, sortable: true, width: 100  }, 
      { field: "", title: '', filter: true, sortable: true, width: 60, template: this.view } 
    ];
  }
  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._currencyunitService.getAllCurrencyUnits('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, 0).subscribe((entities: Array<CurrencyUnit>) => {
      this.currencyunits = {
        data: entities,
        total: entities[0] ? entities[0].TotalCount : 0
      }
    });
  }
  getAllCurrency(filter: string) {
    this._currencyService.getAllCurrency(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Currency>) => {
      this.currency = data;
    })
  }
  onFilterChange(event: any): void {
    if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
      var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
      //1 for gridfilter type
      this._currencyunitService.getAllCurrencyUnits(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, 0).subscribe((currencyunits: Array<CurrencyUnit>) => {
        this.currencyunits = {
          data: currencyunits,
          total: currencyunits[0] ? currencyunits[0].TotalCount : 0
        }
      });
    }
  }
  getAllCurrencyUnit() {
    this._currencyunitService.getAllCurrencyUnits('', Number(this.defaultPageSize), 1, 0, 0).subscribe((currencyunits: Array<CurrencyUnit>) => {
      this.currencyunits = {
        data: currencyunits,
        total: currencyunits[0] ? currencyunits[0].TotalCount : 0
      } 
    })
  };

  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._currencyunitService.deleteCurrencyUnit(this.selectedCurrencyUnit.CurrencyUnit_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearCurrencyUnit();
            this.getAllCurrencyUnit();
          },
          )
        }
      }
    });
  }

  initPageHeader(): PageHeader {
    let headerCurrencyUnit = new PageHeader();
    headerCurrencyUnit.PageCaption = "Currency Unit";
    headerCurrencyUnit.IconClass = "bi bi-shield-shaded";
    return headerCurrencyUnit;
  }

  deleteCurrencyUnit(event: any) {
    if (event.seletedRows[0]) {
      this.selectedCurrencyUnit.CurrencyUnit_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "CurrencyUnit",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }
  goToBackTab(): void {
    this.listView=true;
}
  addCurrencyUnit(event: any) {
    this.listView = false;
    this.clearCurrencyUnit();
    this.getAllCurrency('');
    this.formCaption = "Add Currency Unit";
  }

  editCurrencyUnit(event: any): void {
    if (event.seletedRows[0]) {
      this._currencyunitService.viewCurrencyUnit(event.seletedRows[0]).subscribe((currencyunits: Array<CurrencyUnit>) => {
        let editEnity = currencyunits[0] ? currencyunits[0] : new CurrencyUnit();
        if (editEnity) {
          this.editingEntity = editEnity;
          this.selectedCurrency = { Currency_Id: editEnity.Currency_Id, CurrencyName: editEnity.CurrencyName };
          this.entity = { ...this.editingEntity };

          this.listView = false;
          this.formCaption = "Edit Currency Unit ";
          this.getAllCurrency('');
          this.entity.EntityMetaData = [
            { FieldName: 'CurrencyUnitName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: ' Currency Unit is required' },
            { FieldName: 'CurrencyUnitCode', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' },
          ];
        }
      });
    }
  }

  save(event: any): void {
    if(parseInt(this.entity.CurrencyUnitCode)==0){
      this.notification.showWarning("Zero not allowed")
      return
    }
    this.saveDisabled = true;
    let validations = this._coreSaveService.saveValidation(this.entity);
    if (validations.length === 0) {
      this._currencyunitService.checkDuplication(this.entity.CurrencyUnit_Id,this.entity.CurrencyUnitCode).subscribe((res) => {
        if (res.Success === false) {
          this.notification.showWarning('CurrencyUnit already exists');
          this.saveDisabled = false;
        }
        else { 
          this._currencyunitService.saveCurrencyUnit(this.entity).subscribe(() => {
            if (this.entity.CurrencyUnit_Id == '00000000-0000-0000-0000-000000000000') {
              this.notification.showSuccess('Saved Successfully');
            }
            else {
              this.notification.showSuccess('Updated Successfully');
            }
            this.listView = true;
            this.clearCurrencyUnit();
            this.getAllCurrencyUnit();
          });
        }
      });
    }
    else {
      this.saveDisabled = false;
    }

  }
  AlphabetsOnly(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z\s]*$/.test(inp)) {
      return true;
    } else {
      return false;
    }

  }

  gotoBack(): void {
    this.listView = true;
    this.getAllCurrencyUnit();
  }

  refreshCurrencyUnits(event: any): void {
    this.currencyunits=[];
    this.getAllCurrencyUnit();
  }

  clearCurrencyUnit(): void {
    this.selectedCurrency = {};
    this.entity = new CurrencyUnit();
    this.saveDisabled = false;
  }

  onExcelExport() {
    this.excelexport.save()
  }

  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  public close() {
    this.opened = false;
  }
  public open(dataItem: any): void {
 this.entity.CurrencyUnit_Id=dataItem.CurrencyUnit_Id;
 this.details =[];
 this._currencyunitService.viewCurrencyUnit(this.entity.CurrencyUnit_Id).subscribe((currencyunits: Array<CurrencyUnit>) => {
  this.opened = true;
  this.details = currencyunits[0];
  })}

}
